<div class="container" rtl>
  <div class="row">
    <div class="col-md-12" [ngClass]="routeAnimationsElements">
      <h1 class="main-heading">{{ 'idl.dashboard.title' | translate }}</h1>
    </div>
  </div>
  <br>
  <div class="row">
    <idl-developer-apps-card *nbIsGranted="['view', 'applications_list']" class="col-md-12 mb-2"
      [ngClass]="routeAnimationsElements"></idl-developer-apps-card>
  </div>
  <div class="row">
    <idl-licenses *nbIsGranted="['view', 'my_licenses']" [myLicenses]="true" class="col-md-12 my-2"
      [ngClass]="routeAnimationsElements"></idl-licenses>
  </div>
</div>